// internal-deps
import { Option, Some, None } from "@swiggy-private/js-fp";

import { User } from "@checkout-core/interfaces/User";
import { UserContextValue } from "@checkout-core/contexts/UserContext";
import { getBridgeSdk } from "@checkout-core/utils/BridgeSdk";

export async function getUserInfo(): Promise<Option<User>> {
    const userInfo = await getBridgeSdk().getUserInfo();
    return Some(userInfo).andThen(({ customerId, ...info }) =>
        !customerId || customerId == "0" ? None : Some<User>({ userId: customerId, ...info }),
    );
}

export const getUserFromUserContextValue = (userContextValue: UserContextValue["user"]): User | undefined =>
    userContextValue.match({
        some: val => val,
        none: undefined,
    });
